module.exports = __webpack_public_path__ + "img/CIELUV.53454491.jpg";